import { checkStatus } from '../fetch';
import { createQueryString } from '../utilities';
import { editableTagsPath, taggingsPath } from '../api_relative_paths';

/**
 * Retrieve all current user's tags
 *
 * @returns {Promise} Promise that can be extended
 */
const getAllTags = () => {
  const url = `${editableTagsPath}${createQueryString()}`;
  return fetch(url)
    .then(checkStatus)
    .then(response => response.json());
};

/**
 * Create one or a series of consultant taggings (meaning adding one or several consultants to a
 * folder)
 *
 * @param {Array | number | string} taggableIds - Array of IDs or one ID as string or number
 * @param {string} folderName  - Name of folder
 * @returns {Promise} Promise that can be extended
 */
const addConsultantTagging = (taggableIds, folderName) => {
  const tagIdsArray = !Array.isArray(taggableIds) ? [taggableIds] : taggableIds;

  const queryStringParams = {
    taggings: tagIdsArray.map(id => ({
      taggable_id: id,
      taggable_type: 'Consultant',
      name: folderName
    }))
  };

  const url = `${taggingsPath}${createQueryString(queryStringParams)}`;
  return fetch(url, {method: 'POST'})
    .then(checkStatus)
    .then(response => response.json());
};

/**
 * Remove a series of taggings using their ID
 *
 * @param {Array} ids - id of tagging to delete
 * @returns {Promise} Promise that can be extended
 */
const removeTaggings = (ids = []) => {
  const queryStringParams = createQueryString({ taggings: ids, });

  return fetch(`${taggingsPath}/${queryStringParams}`, { method: 'DELETE' })
    .then(checkStatus)
    .then(response => response.json());
};

/**
 * Fetch taggings based on IDs
 *
 * @param {Array | number | string} taggableIds - Array of IDs or one ID as string or number
 * @returns {Promise} Promise that can be extended
 */
const queryTaggings = taggableIds => {
  const tagIdsArray = !Array.isArray(taggableIds) ? [taggableIds] : taggableIds;

  const queryStringParams = {
    filter: {
      taggable_ids: tagIdsArray,
      taggable_type: 'Consultant'
    },
    page: {size: 100}
  };

  return fetch(`${taggingsPath}${createQueryString(queryStringParams)}`)
    .then(checkStatus)
    .then(response => response.json());
};

export {
  getAllTags,
  addConsultantTagging,
  queryTaggings,
  removeTaggings,
};
